import { useContext } from 'react';
import Context from '../../Context';

export interface TitleHook {
  title?: string | null;
}

export default function useTitle(): TitleHook {
  const { job } = useContext(Context);

  return {
    title: job?.title,
  };
}
